import React from 'react';

const TaxonomyBarTab = (props) => (
  <button
    className={`collections-taxonomy-bar__tab ${(props.selected) ? 'selected' : ''}`}
    onClick={() => props.handleTabClick(props.label)}
  >
    <div className="contents">
      {props.label}
    </div>
  </button>
);

export default TaxonomyBarTab;